/* eslint-disable max-len */
import DogeQuestion from 'images/coin-pages/questions/doge.svg'

import { slides } from 'pages/home/components/swiper-component/assets/slides'

import { ICoinPageData } from '../types'

export const dogePage: ICoinPageData = {
  title: 'coin_297',
  description: 'coin_298',
  // description: 'coin_299',
  h1: (t, locale, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Dogecoin' }) }}
    />
  ),
  questionsBlock: {
    image: DogeQuestion,
    questions: [
      {
        title: 'coin_300',
        answer: 'coin_301',
      },
      {
        title: 'coin_302',
        answer: 'coin_303',
      },
      {
        title: 'coin_304',
        answer: 'coin_305',
      },
      {
        title: 'coin_306',
        answer: 'coin_307',
      },
      {
        title: 'coin_308',
        answer: 'coin_309',
      },
      {
        title: 'coin_310',
        answer: 'coin_311',
      },
    ],
  },
  whatIs: {
    slides: slides,
    text: [],
    paragraphs: [
      {
        title: 'coin_312',
        text: ['coin_315'],
      },
      {
        title: 'coin_313',
        text: ['coin_316', 'coin_317', 'coin_318', 'coin_319'],
      },
      {
        title: 'coin_314',
        text: ['coin_320', 'coin_321', 'coin_322', 'coin_323'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/dogecoin-rise-with-crypto-loans/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/05/Dogecoin-Rise-With-Crypto-Loans145632.png',
        imageAlt: 'Dogecoin (DOGE) Cryptocurrency review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/why-to-get-a-loan-in-dogecoin/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1020/https://coinrabbit.io/blog/wp-content/uploads/2021/04/photo_2021-05-14_22-06-44.jpg',
        imageAlt: 'Dogecoin (DOGE) Cryptocurrency review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Dogecoin (DOGE) Cryptocurrency review 7',
      },
    ],
  },
}
